import { Table } from "antd";
import axios from "axios";
import React, { Component } from "react";

export default class Overview extends Component {
  state = {
    loading: false,
    data: [],
  };

  componentDidMount = () => {
    const { history } = this.props;

    this.setState({
      loading: true,
    });
    axios({
      method: "get",
      url: "/analytics/careware_analytics",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        console.log(response.data);
        this.setState({
          loading: false,
          data: response.data.data,
        });
      })
      .catch(() => {
        history.push("/login");
      });
  };

  render() {
    const { loading, data } = this.state;

    const columns = [
      {
        title: "Partner Name",
        dataIndex: "partner_name",
        fixed: "left",
        width: 200,
        align: "center",
      },
      {
        title: "Acquired",
        dataIndex: "total_orders",
        width: 200,
        align: "center",
      },
      {
        title: "Active",
        dataIndex: "total_active_orders",
        // width: 200,
        align: "center",
      },
      {
        title: "Single Refill",
        dataIndex: "active_single_refill",
        // width: 200,
        align: "center",
      },
      {
        title: "Multiple Refill",
        dataIndex: "active_multiple_refill",
        // width: 200,
        align: "center",
      },
      {
        title: "Retention (%)",
        render: (record) => (
          <p>
            {(
              (record.active_multiple_refill * 100) /
              record.total_orders
            ).toFixed(2)}{" "}
            %
          </p>
        ),
        align: "center",
      },
      {
        title: "On Hold",
        dataIndex: "on_hold",
        // width: 200,
        align: "center",
      },
      {
        title: "Inactive",
        dataIndex: "inactive_orders",
        // width: 200,
        align: "center",
      },
      {
        title: "Treatment Complete",
        dataIndex: "t_comp",
        // width: 200,
        align: "center",
      },
    ];

    return (
      <div style={{ textAlign: "center" }}>
        <h2>Overview</h2>
        <hr width="120" />

        <Table
          style={{ marginTop: "5%" }}
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered
          pagination={false}
          scroll={{ x: 1100 }}
          size="small"
          rowKey="partner_name"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Analytics/Overview.js